// client/src/App.js
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { HomeScreen } from './components/HomeScreen';
import { TeamsScreen } from './components/TeamsScreen';
import {OrgProvider} from './lib/OrgProvider';
import './App.css';

function App() {
  // No more useState for screen — the URL is now the source of truth.
  // useLocation reads the current path so we can bold the active nav link.
  return(
    //OrgProvider fetches /me once and exposes it via useMe()/useOrg().
    //Everything inside this provider can assume the user is loaded.
    <OrgProvider>
    <AppShell />
    </OrgProvider>
  );
}
// Split out so AppShell can use hooks that depend on OrgProvider being
// mounted above it. (Calling useOrg() in App() directly would throw,
// because App is what mounts OrgProvider.)

function AppShell(){
  const location = useLocation();

  return (
    <div>
      <nav style={{
        padding: '12px 20px',
        borderBottom: '1px solid #ddd',
        fontFamily: 'sans-serif',
        display: 'flex',
        gap: 12,
      }}>
        <Link
          to="/"
          style={{
            fontWeight: location.pathname === '/' ? 'bold' : 'normal',
            textDecoration: 'none',
            color: 'inherit',
          }}
        >
          Home
        </Link>
        <Link
          to="/teams"
          style={{
            fontWeight: location.pathname === '/teams' ? 'bold' : 'normal',
            textDecoration: 'none',
            color: 'inherit',
          }}
        >
          Teams
        </Link>
      </nav>

      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/teams" element={<TeamsScreen />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}


function NotFound() {
  return (
    <div style={{ padding: 20, fontFamily: 'sans-serif' }}>
      <h2>Page not found</h2>
      <p>
        <Link to="/">Go home</Link>
      </p>
    </div>
  );
}

export default App;